var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.show ? _c('div', {
    staticClass: "f-empty",
    style: Object.assign({}, _vm.customStyle)
  }, [_vm.type === 'order' ? _c('img', {
    attrs: {
      "src": require("../../assets/empty.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/empty2.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }